export default __webpack_public_path__ + "static/media/plants-coins-house1.1cbcf59f.jpg";